import React, { useState } from 'react';

// Builds a truncated page list: always show first/last page plus a window
// around the current page, collapsing gaps into '...' so the control stays
// compact even with thousands of pages.
const getPageNumbers = (current, total, delta = 2) => {
  const range = [];
  const withDots = [];
  let last;

  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
      range.push(i);
    }
  }

  range.forEach(i => {
    if (last) {
      if (i - last === 2) {
        withDots.push(last + 1);
      } else if (i - last > 1) {
        withDots.push('...');
      }
    }
    withDots.push(i);
    last = i;
  });

  return withDots;
};

const Pagination = ({ inputListPerPage, totalInputList, paginate, currentPage }) => {
  const totalPages = Math.ceil(totalInputList / inputListPerPage);
  const [jumpValue, setJumpValue] = useState('');

  if (totalPages <= 1) return null;

  const pageNumbers = getPageNumbers(currentPage, totalPages);

  const jumpToPage = () => {
    const target = parseInt(jumpValue, 10);
    if (target >= 1 && target <= totalPages) {
      paginate(target);
    }
    setJumpValue('');
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '12px'
      }}
    >
      <ul className="pagination" style={{ marginBottom: 0 }}>
        {pageNumbers.map((number, index) =>
          number === '...' ? (
            <li key={`ellipsis-${index}`} className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          ) : (
            <li
              key={number}
              className={`page-item${number === currentPage ? ' active' : ''}`}
            >
              <a
                onClick={e => {
                  e.preventDefault();
                  paginate(number);
                }}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    paginate(number);
                  }
                }}
                className="page-link"
              >
                {number}
              </a>
            </li>
          )
        )}
      </ul>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px' }}>
        <span>Go to page</span>
        <input
          type="number"
          min={1}
          max={totalPages}
          value={jumpValue}
          onChange={e => setJumpValue(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              jumpToPage();
            }
          }}
          placeholder={String(currentPage)}
          style={{ width: '64px', padding: '2px 6px' }}
        />
        <span>of {totalPages}</span>
        <button type="button" onClick={jumpToPage} className="btn btn-sm btn-outline-secondary">
          Go
        </button>
      </div>
    </div>
  );
};

export default Pagination;
